import { useState, useEffect } from "react"

export const useOpenDepositRemoveOfferModal = ({ hideOfferPostState, resetHideDepositOfferPost }) => {
    const [openRemoveOfferModal, setOpenRemoveOfferModal] = useState(false)

    const handleOpenRemoveOfferModal = () => {
        if (!openRemoveOfferModal) {
            resetHideDepositOfferPost()
        }
        setOpenRemoveOfferModal(open => !open)
    }
    
    useEffect(() => {
        if (hideOfferPostState.success && openRemoveOfferModal) {
            handleOpenRemoveOfferModal()
        }
    }, [hideOfferPostState])

    return { handleOpenRemoveOfferModal, openRemoveOfferModal }
}
